function initContactImport() {
  initSidebarButtons();
  initListeners();
}

function initListeners() {
  $('input[name="select_all"]').click(function () {
    $('input[name^="select_"][type=checkbox]').prop('checked', true);
  });
}

function initSidebarButtons() {

  $('#saveContactsAction').click(function () {
    var target = $(this).attr('data-targetform');
    var $target = $(target);
    var l = Ladda.create(this);
    l.start();
    $.post($target.attr('action'), $target.serialize())
      .done(function (data) {
        if (data.status) {
          $('.slidePanel-close').trigger('click');
          location.replace(data.redirect);
        }
      })
      .always(function () {
        l.stop();
      });
  });
}
